const Event = require('../../../entities/Event');
const { Age } = require('../../Constants');
const EventNames = require('../../Names/EventNames');

class DevelopmentOfAgriculture extends Event {
    constructor(){
        super(
            Age.AgeA,
            EventNames.DevelopmentOfAgriculture,
            "Each Civilization gains 2 food.",
            {}
        )
    }
}

module.exports = DevelopmentOfAgriculture;